export const documentEndpoints = (builder) => ({
    getDocumentsByModule: builder.query({
        query: (moduleName) => ({
            url: `/common/documents/${moduleName}`,
            method: 'GET',
        }),
        providesTags: ['Document'],
    }),
    getUploadedDocuments: builder.query({
        query: ({ moduleName, referenceId }) => ({
            url: `/common/uploaded-documents/${moduleName}/${referenceId}`,
            method: 'GET',
        }),
        providesTags: ['Document'],
    }),
    uploadDocument: builder.mutation({
        query: (formData) => ({
            url: '/common/upload-document',
            method: 'POST',
            body: formData,
        }),
        invalidatesTags: ['Document'],
    }),
});
